import type { User } from "../../../api/types";
import { Button } from "../../../components/Button";
import { Modal } from "../../../components/Modal";
import "../../../components/Form.css";

interface RemoveUserDialogProps {
  user: User | null;
  isRemoving: boolean;
  onCancel: () => void;
  onConfirm: () => void;
}

/**
 * Confirms `DELETE /api/users/{id}` — the server decides deactivate vs.
 * true delete (client.ts), so the copy here stays deliberately generic
 * about which one happens. Guard errors ("cannot remove the last admin",
 * "cannot deactivate yourself") come back as the mutation's error and are
 * shown as a toast by the caller (UsersPage), not here.
 */
export function RemoveUserDialog({ user, isRemoving, onCancel, onConfirm }: RemoveUserDialogProps) {
  return (
    <Modal open={user !== null} title="Remove user" onClose={onCancel}>
      <p>
        Remove <strong>{user?.username}</strong>? They'll immediately lose access. This can't be undone from here —
        re-adding them creates a new account.
      </p>
      <div className="form-actions">
        <Button type="button" variant="secondary" onClick={onCancel} disabled={isRemoving}>
          Cancel
        </Button>
        <Button type="button" variant="danger" onClick={onConfirm} disabled={isRemoving}>
          {isRemoving ? "Removing…" : "Remove"}
        </Button>
      </div>
    </Modal>
  );
}
